import { ConditionCategory as ConditionCategoryEnum } from "@sinch/core/entities/serverEnums";
import type { ConditionCategory } from "@sinch/types/sinch.types";
import { useTranslation } from "react-i18next";

/**
 * Label shown in place of a condition subject (badge, attribute) that was deleted after the ratelist was saved.
 */
export const useDeletedConditionSubjectLabel = () => {
  const { t } = useTranslation();

  const getDeletedSubjectLabel = (category: ConditionCategory | ConditionCategoryEnum | null | undefined): string => {
    switch (category) {
      case ConditionCategoryEnum.Badge:
        return t("RateBuilder.deletedBadge");
      case ConditionCategoryEnum.PersonalAttribute:
      case ConditionCategoryEnum.ProfileAttribute:
        return t("RateBuilder.deletedAttribute");
      default:
        return t("RateBuilder.deletedConditionSubject");
    }
  };

  return { getDeletedSubjectLabel };
};
